import { container } from "@/inversify.config";
import { OperationInitTypes } from "../../models/enums/operationInitTypes";
import { CatalogOperationModel } from "../../models/operations/catalogOperationModel";
import { OperationDetailsModel } from "../../models/operations/operationDetailsModel";
import IOperationsHistoryService from "../../services/history/IOperationsHistoryService";
import { DiTokens } from "../../services/diTokens";
import IOperationService from "../../services/operations/IOperationService";
import { ConfigStore } from "../../store/modules/config";
import { ContractsStore } from "../../store/modules/contracts";
import { CatalogStore } from "../../store/modules/catalog";
import { PersonStore } from "../../store/modules/person";
import { Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { AppStore } from "../../store/modules/app";
import { searchCatalogById } from "../../utilities/index";
import { OperationVue } from "./OperationVue";
import { OperationPropertyModel } from "../../models/operations/operationPropertyModel";
import i18n from "@/i18n";
import { Dictionary } from "../../data/types";
import { CatalogOperationTypes } from "../../data/enums/catalogOperationTypes";


/**Модель представления операции */
export class CatalogOperationVue extends OperationVue {
  /** Id операции в каталоге */
  @Prop() operId!: number;

  @Prop() addInitData!: Dictionary<string>;

  @Prop() backLinkFunc!: Function;

  /** Тип инициализации операции  */
  @Prop() operInitType!: OperationInitTypes;

  @Watch("operId", { immediate: true })
  async operIdChanged() {
    await this.init();
  }

  // @Watch("accntInModalShow", { immediate: true })
  // async accntInModalClose(val: boolean) {
  //   if (val === false) {
  //     this.appStore.setLoading(true);
  //     await this.destroyForm();
  //     await this.init();
  //     this.appStore.setLoading(false);
  //   }
  // }

  async accountInClose(): Promise<void> {
    this.appStore.setLoading(true);
    if (this.isSBPOperToMySelf && this.personStore.personInfo.Data.DefaultInAccount.length === 0) {
      this.$router.back();
    } else {
      await this.destroyForm();
      await this.init();
    }
    this.accntInModalShow = false;
    this.appStore.setLoading(false);
  }

  @Watch('OperationModel.ActionStateText', { immediate: true })
  textChanged(val) {
    if (val === 'Необходимо разрешить исходящие переводы по Системе быстрых платежей в настройках.') {
      this.modalShow = true;
      this.sbpOutError = true;
      setTimeout(() => { this.sbpOutError = false; }, 500);
    } else {
      this.modalShow = false;
    }
  }

  @Watch('OperationModel.PrepareData', { immediate: true })
  afterPrepareFunc(val: any): void {
    if (!val) {
      this.messageAfterTariff = null;
    }
  }

  /**Стор настроек */
  get appStore(): AppStore {
    return getModule(AppStore, this.$store);
  }

  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  get caption(): string {
    return this.$route.query["_categoryName"] || this.OperationModel?.Declaration?.Caption;
  }
  get operPicture(): string {
    return this.$route.query["_categoryImg"] || this.OperationModel?.Picture;
  }

  get assignAction(): (prop: OperationPropertyModel) => Promise<void> {
    return async (prop: OperationPropertyModel) => {
      if (!this.focusedPropertyModel) {
        this.focusedPropertyModel = prop;
      }
      let propertyName: string = prop.Declaration.Name;
      if (prop.errorText.length > 0)
        prop.errorText = '';
      if (propertyName === 'contract' || propertyName === 'contractTo')
        this.OperationModel.contractChange(propertyName, this.contractsStore.contracts);
      if (prop.isSubProp) {
        const propIndex: number = this.OperationModel.Properties.find((prp: OperationPropertyModel) => prp.Declaration.Name === prop.parentName)?.objectActiveIndex;
        propertyName = `${prop.parentName};${propIndex};${prop.Declaration.Name}`;
      }
      await this.assign(propertyName);
    };
  }

  get tariffInfo(): string | null {
    let sTariff: string | null = i18n.t("main.operation.form.comissMaybe").toString();
    const extMessage: OperationPropertyModel = this.OperationModel.Properties.find((prop: OperationPropertyModel) => prop.Declaration.Name === 'extMessage');

    if (extMessage)
      return extMessage.Value || extMessage.Declaration.Default;
    
    if (this.operId.toString() == this.configStore.apiData.OperationCodeOfToOtherContractByCard && this.OperationModel && this.OperationModel.Properties) {

      try {
        const type = this.OperationModel.Properties.find((p: OperationPropertyModel) => {
          return p.Declaration.Name == "type";
        });

        if (type && type.Value) {
          const operType = type.Value;
          if (operType == "Own" || operType == "OwnBank") {
            sTariff = i18n.t("main.operation.form.noComiss").toString();
            // this.tariffWithLink = false;
          } else if (operType == "OtherBank") {
            sTariff = `${i18n.t("main.operation.form.comissMaybe").toString(0)}`;
            // this.tariffWithLink = true;
          }
        }
      } catch (e) {
        console.log(e)
      }

    } else if (this.isSBPOper && this.OperationModel && this.OperationModel.Properties) {

      try {
        const type = this.OperationModel.Properties?.find((p: OperationPropertyModel) => {
          return p.Declaration.Name == "type";
        });

        if (type && type.Value) {
          const operType = type.Value.Value;
          if (operType === 'Банк Финсервис')
            sTariff = i18n.t("main.operation.form.noComiss").toString();
          else
            sTariff = i18n.t("main.operation.form.comissMaybe").toString();
        }
      } catch (e) {
        console.log(e)
      }

    } else if (this.operId.toString() === this.configStore.apiData.OperationCodeOfToExt && this.OperationModel && this.OperationModel.Properties) {
      sTariff = i18n.t("main.operation.form.comissMaybeWithDraw").toString();
    } else if (this.operId.toString() === this.configStore.apiData.OperationCodeOfToContract && this.OperationModel && this.OperationModel.Properties) {
      const contractTo: OperationPropertyModel = this.OperationModel.Properties.find((prop: OperationPropertyModel) => prop.Declaration.Name == 'contractTo');
      const contract: OperationPropertyModel = this.OperationModel.Properties.find((prop: OperationPropertyModel) => prop.Declaration.Name == 'contract');
      if (contract && contractTo) {
        const contractToAcc: any = this.contractsStore.contracts.getContractByRefId(contractTo.Value.Key);
        const contractAcc: any = this.contractsStore.contracts.getContractByRefId(contract.Value.Key);
        if (contractToAcc && contractAcc) {
          if (contractToAcc.Currency === contractAcc.Currency)
            sTariff = i18n.t("main.operation.form.noComiss").toString();
          else
            sTariff = i18n.t("main.operation.form.comissMaybe").toString();
        }
      }
    }

    return sTariff;
  }

  get isTariff(): boolean {
    return this.OperationModel.Properties.find((p: OperationPropertyModel) => {
      return p.Declaration.Name == "tariff";
    }) ? true : false; 
  }

  get tariffValue(): string {
    let tariff: OperationPropertyModel = this.OperationModel.Properties.find((p: OperationPropertyModel) => {
      return p.Declaration.Name == "tariff";
    });
    const currency: string = tariff && tariff.CurrensySymbol ? tariff.CurrensySymbol : this.OperationModel.Properties.find((p: OperationPropertyModel) => {
      return p.Declaration.Name == 'sum';
    })?.CurrensySymbol;
    const res: string = tariff && tariff.Value != 0 ? `${tariff.Value} ${currency}` : i18n.t("main.operation.form.dontComiis");
    return this.isSBPOperToMySelf ? i18n.t("main.operation.form.comissMaybe") : res;
  }

  get detailsFS(): Array<any> {
    if (this.OperationModel.PrepareData && Object.keys(this.OperationModel.PrepareData).length > 0) {
      const res: Array<any> = [];
      for (const key in this.OperationModel.PrepareData) {
        if (key !== 'messageAfterTariff') {
          res.push({
            name: key,
            isWrapped: true,
            textVal: this.OperationModel.PrepareData[key]
          });
        } else {
          this.messageAfterTariff = this.OperationModel.PrepareData[key];
        }
      }
      return res;
    }
    const keys: Array<string> = ['receiverName', 'contractTo', 'bankID', 'sum']; // 'sbpID'
    const res: Array<any> = [{
      name: 'Тип перевода',
      isImage: true,
      textVal: require('../../../../public/img/sbp_det.png')
    }];
    keys.map((key: string) => {
      const prop: OperationPropertyModel = this.OperationModel.Properties.find((p: OperationPropertyModel) => p.Declaration.Name == key);
      if (prop && prop.Value) {
        if (key == 'sum')
          res.push({
            name: prop.Declaration.Caption,
            textVal: this.$options.filters.sum(prop.Value) + ' ' + prop.CurrensySymbol
          });
        else if (key == 'bankID' && this.operId.toString() === this.configStore.apiData.OperationCodeOfMe2MeOperation)
          res.push({
            name: i18n.t('main.operation.form.bankSender'),
            textVal: prop.Value.Value ? prop.Value.Value : prop.Value
          });
        else
          res.push({
            name: prop.Declaration.Caption,
            isWrapped: key === 'sbpID',
            textVal: prop.Value.Value ? prop.Value.Value : prop.Value
          });
      } else if (!prop && key === 'contractTo') {
        res.push({
          name: 'Номер телефона отправителя',
          textVal: this.$options.filters.phoneNumber(this.personStore.personInfo.Data.MobileTel)
        })
      }
    });
    res.push({
      name: i18n.t('main.operation.form.commiss'),
      textVal: this.tariffValue
    })
    return res;
  }

  get needDetailsFS(): boolean {
    if (this.isSBPOper) {
      if (this.OperationModel.Properties.find((p: OperationPropertyModel) => p.Declaration.Name == 'type').Value.Key == 'SBP') {
        return true;
      }
    } else if (this.isSBPOperToMySelf)
      return true;
    return this.OperationModel.PrepareData && Object.keys(this.OperationModel.PrepareData).length > 0 ? true : false;
  }

  get isSBPOper(): boolean {
    return this.operId.toString() === this.configStore.apiData.OperationCodeOfSbpOperation;
  }

  get isSBPOperToMySelf(): boolean {
    return this.operId.toString() === this.configStore.apiData.OperationCodeOfMe2MeOperation;
  }

  get catalogStore(): CatalogStore {
    return getModule(CatalogStore, this.$store);
  }

  get detailsService(): IOperationsHistoryService {
    return container.get<IOperationsHistoryService>(DiTokens.OperationsHistoryService);
  }

  get catalogParentOper(): any {
    return searchCatalogById(this.catalogStore.catalog, searchCatalogById(this.catalogStore.catalog, this.OperationModel.RespondentCode)?.ParentId);
  }

  get confirmText(): string {
    const transferKeys: Array<string> = [
      this.configStore.apiData.OperationCodeOfToContract,
      this.configStore.apiData.OperationCodeOfSbpOperation,
      this.configStore.apiData.OperationCodeOfToOtherContractByPhone,
      this.configStore.apiData.OperationCodeOfToOtherContractByCard,
      this.configStore.apiData.OperationCodeOfToExt
    ]
    if (this.OperationModel.RespondentCode === this.configStore.apiData.OperationCodeOfMe2MeOperation) {
      return i18n.t("main.operation.form.transferMySelf");
    } else if (transferKeys.indexOf(this.OperationModel.RespondentCode) !== -1) {
      return i18n.t("main.operation.form.transfer");
    } else
      return i18n.t("main.operation.form.pay");
    // if (this.catalogParentOper) {
    //   if (this.OperationModel.RespondentCode )
    //     return i18n.t("main.operation.form.transfer");
    //   else if (this.catalogParentOper.Caption == 'ОПЛАТИТЬ' || this.catalogParentOper.Caption == 'ТЕЛЕФОН' || this.catalogParentOper.Caption == "Платежи")
    //     return i18n.t("main.operation.form.pay");
    // } else if (this.catalogParentOper == undefined)
    //   return i18n.t("main.operation.form.pay");
    // return i18n.t("main.operation.form.continue");
  }

  /**Модель операции */
  public OperationModel: CatalogOperationModel = new CatalogOperationModel();

  modalShow: boolean = false;

  successDetails: OperationDetailsModel = null;

  accntInModalShow: boolean = false;

  sbpOutError: boolean = false;

  createTemplateMode: boolean = false;

  focusedPropertyModel: OperationPropertyModel = null;

  messageAfterTariff: string | null = null;

  // blockAssign: boolean = false;

  // tariffWithLink: boolean = false;

  print() {
    const link = this.$options.filters.url(
      `Operations/Print/${this.successDetails.OperationData.Id}`
    );
    window.open(link, "_blank");
  }

  get onFocusAction(): (e: any) => void {
    return (e: any) => {
      // if (!this.focusedPropertyModel && !e.prop)
      //   this.blockAssign = true;
      this.focusedPropertyModel = e?.prop;
    };
  }

  async assign(propertyName: string): Promise<void> {
    try {
      if (!this.isInit || this.assignProcess) {
        return;
      }
      this.assignProcess = true;
      if (propertyName == 'sum')
        this.validateForm();
        
      const tempPropertyErrorsComes = this.OperationModel.propertyErrorsComes;

      this.OperationModel = (await this.service.assign(
        propertyName,
        this.OperationModel
      )) as CatalogOperationModel;
      if(tempPropertyErrorsComes && !this.OperationModel.propertyErrorsComes)
        this.resetFormValidation();
      this.assignProcess = false;
      if (this.prepareAfterAssing === true) {
        await this.next();
        this.prepareAfterAssing = false;
      }
    }
    catch (e) {
      this.prepareAfterAssing = false;
      this.assignProcess = false;
      throw e;
    }
  }

  /**Инициализация формы */
  async init(): Promise<void> {
    if (this.operId) {
      this.service = container.get<IOperationService>(
        DiTokens.CatalogOperationService
      );
      if (this.contractsStore.contracts.isEmpty) {
        this.contractsStore.addMethod(async () => {
          await this.initOperation();
        });
        return;
      }
      await this.initOperation();
      if (this.isSBPOperToMySelf && this.personStore.personInfo.Data.DefaultInAccount.length === 0) {
        this.alertService.sbp(i18n.t('main.settings.errors.sbpInAcntinclude'), true);
        this.accntInModalShow = true;
        return;
      }
    }
  }

  async nextStep(): Promise<void> {
    if ((this.OperationModel as CatalogOperationModel).catalogOperationType === CatalogOperationTypes.SBP && !this.personStore.personInfo.Data.EnableSbpOut) {
      this.alertService.sbp(i18n.t('main.settings.errors.sbpOutinclude'), true);
      this.modalShow = true;
      this.sbpOutError = true;
      setTimeout(() => { this.sbpOutError = false; }, 500);
    } else if (this.isSBPOperToMySelf && this.personStore.personInfo.Data.DefaultInAccount.length === 0) {
      this.alertService.sbp(i18n.t('main.settings.errors.sbpInAcntinclude'), true);
      this.accntInModalShow = true;
    } else {
      // this.OperationModel.Properties.forEach((prop: OperationPropertyModel) => {
      //   if (prop.errorText.length > 0) {
      //     prop.errorText = '';
      //     prop.loadCheckRules();
      //   }
      // });
      if (this.focusedPropertyModel) {
        await this.assignAction(this.focusedPropertyModel);
        this.focusedPropertyModel = null;
      }
      await this.next();
    }
  }

  /**Метод для выполнения после успешного проведения */
  async afterExecute(): Promise<void> {
    // await this.destroyForm();

    this.appStore.setLoading(true);
    this.appStore.setCatalogFlag(true);
    if (this.$route.query.contractTo)
      this.$router.push(
        `/contractUpCatalog?${this.$route.query.id ? `id=${this.$route.query.id}&` : ''}${this.$route.query.type ? `type=${this.$route.query.type}&` : ''}${this.$route.query.contractTo ? `contractTo=${this.$route.query.contractTo}&` : ''}${this.$route.query.contract ? `contract=${this.$route.query.contract}&` : ''}operId=${this.OperationModel.OperationId}`
      );
    else if (this.$route.query.card)
      this.$router.push(
        `/contractUpCatalog?card=${this.$route.query.card}&operId=${this.OperationModel.OperationId}`
      );
    else
      this.$router.push(`/payments?${this.$route.query.contract ? `contract=${this.$route.query.contract}&` : ''}operId=${this.OperationModel.OperationId}`);
    // this.successDetails = await this.detailsService.getOperationDetails({ Id: this.OperationModel.OperationId, ReferenceId: "" });
    // this.appStore.setLoading(false);
  }

  /**Инициализация операции */
  async initOperation(): Promise<void> {
    this.loading = true;
    let addInitData: Dictionary<string> = {};
    for (const i in this.$route.query) {
      addInitData[i] = this.$route.query[i];
    }
    if (Object.keys(addInitData).length === 0 && !!this.addInitData)
      addInitData = this.addInitData;

    this.OperationModel = (await this.service.init(
      this.operId,
      this.operInitType,
      addInitData
    )) as CatalogOperationModel;

    this.loading = false;
  }
}
